import React from "react";

const Java_Package = () => {
  return (
    <div>
      <h1>Java Package</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Package in Java.</p>
    </div>
  );
};

export default Java_Package;
